import { render, staticRenderFns } from "./software.vue?vue&type=template&id=42aa8ccf&scoped=true"
var script = {}
import style0 from "./software.vue?vue&type=style&index=0&id=42aa8ccf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aa8ccf",
  null
  
)

export default component.exports